<template>
  <ais-instant-search :search-client="searchClient" index-name="tools">
    <v-container fluid id="toolSearch">
      <v-btn
        fab
        dark
        fixed
        bottom
        right
        color="rgba(22, 55, 88, 0.9)"
        @click="toTop"
        small
        class="d-sm-none"
      >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
      <!-- SEARCH -->
      <v-row wrap justify="center">
        <v-col cols="8" xs="8" sm="9" class="py-0 pb-2 px-0">
          <ais-search-box>
            <div slot-scope="{ currentRefinement, refine }">
              <v-text-field
                type="search"
                solo-inverted
                flat
                hide-details
                label="Search Tools"
                prepend-inner-icon="search"
                color="secondary"
                v-model="currentRefinement"
                clearable
                @click:clear="refine()"
                @input="search(refine, $event)"
              >
              </v-text-field>
            </div>
          </ais-search-box>
        </v-col>
        <v-col cols="3" xs="3" sm="2" class="py-0 pr-0">
          <v-btn color="primary" large height="48" block to="/tools/cart">
            <v-icon>shopping_cart</v-icon>
          </v-btn>
        </v-col>
        <!-- start CATEGORIES -->
        <v-col cols="11" xs="12" class="py-0 px-0">
          <ais-menu attribute="category" :sort-by="['name:asc']">
            <div slot-scope="{ items, refine }">
              <v-sheet elevation="1" class="py-0 px-1" color="white">
                <ais-stats>
                  <div
                    slot-scope="{ nbHits }"
                    class="pa-2 pb-0 mb-0 font-weight-regular caption grey--text text-right"
                  >
                    <span v-if="items.find((i) => i.isRefined)" class="mr-2">
                      Filtered by
                      {{ items.find((i) => i.isRefined).value }}</span
                    >{{ nbHits }} Results
                  </div>
                </ais-stats>
                <v-chip-group>
                  <v-chip
                    :class="{ primary: item.isRefined }"
                    v-for="item in items"
                    :key="item.value"
                    small
                    @click.prevent="filter(refine, item.value)"
                    >{{ item.value }}</v-chip
                  >
                </v-chip-group>
              </v-sheet>
            </div>
          </ais-menu>
        </v-col>
        <!-- end CATEGORIES -->

        <!-- start TOOL LIST -->
        <v-col cols="11" xs="12" class="px-0">
          <ais-configure
            highlightPreTag="__highlight__"
            highlightPostTag="__/highlight__"
            :filters="`NOT _tags:disabled`"
          />
          <ais-hits :escapeHTML="false">
            <div slot-scope="{ items }">
              <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="20"
                class="mb-4 pb-4 elevation-1"
                disable-sort
              >
                <template v-slot:item.image="{ item }">
                  <div class="py-2">
                    <v-img :src="item.image" width="60" height="60" contain />
                  </div>
                </template>
                <template v-slot:item.title="{ item }">
                  <strong class="grey--text text--darken-3">
                    <non-escaped-highlight :hit="item" attribute="title" />
                  </strong>
                </template>
                <template v-slot:item.description="{ item }">
                  <non-escaped-highlight
                    :hit="item"
                    attribute="description"
                    class="caption-plus"
                  />

                  <span
                    class="caption-plus grey--text text--darken-2 d-sm-inline"
                  >
                    {{ item.keyFeature1 }}
                  </span>

                  <span
                    class="caption grey--text text--darken-2 d-none d-sm-inline"
                    v-if="item.keyFeature2"
                  >
                    <br />
                    {{ item.keyFeature2 }}
                  </span>
                  <span
                    class="caption grey--text text--darken-2 d-none d-sm-inline mb-1"
                    v-if="item.keyFeature2"
                  >
                  </span>
                </template>
                <template v-slot:item.other="{ item }">
                  <v-btn
                    color="primary"
                    small
                    outlined
                    @click.stop="viewTool(item)"
                    ><v-icon left small>add</v-icon> add to order</v-btn
                  >
                </template>
              </v-data-table>
              <v-dialog v-model="viewToolDialog" max-width="600">
                <v-card v-if="currentTool">
                  <v-card-text class="px-1 py-0">
                    <v-container fluid>
                      <v-row wrap justify="start">
                        <v-col cols="4" xs="4">
                          <v-img
                            :src="currentTool.image"
                            width="120"
                            height="120"
                            contain
                          />
                        </v-col>

                        <v-col cols="8" xs="8">
                          <h1 class="subtitle-1">
                            <strong>{{ currentTool.title }}</strong>
                          </h1>
                          <p>{{ currentTool.description }}</p>
                          <p class="text-right mb-0">
                            <v-icon
                              @click="currentTool.qty--"
                              :disabled="currentTool.qty == 0"
                              >remove_circle_outline</v-icon
                            >
                            <v-text-field
                              class="d-inline-block ml-2 centered-input qty"
                              name="qty"
                              v-model.number="currentTool.qty"
                              style="width:60px"
                              dense
                              type="number"
                              @blur="$store.commit('newOnBlur')"
                            ></v-text-field>
                            <v-icon @click="currentTool.qty++" class="ml-2"
                              >add_circle_outline</v-icon
                            >
                          </p>
                          <div class="text-right green--text" v-if="inCartQty">
                            {{ inCartQty }} in Cart
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-divider></v-divider>
                  </v-card-text>

                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="viewToolDialog = false">
                      Cancel
                    </v-btn>

                    <v-btn
                      color="primary"
                      @click="addToCart(currentTool)"
                      class="px-4"
                      :disabled="currentTool.qty == 0"
                    >
                      Add to Cart
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </ais-hits>
        </v-col>
        <!-- end TOOL LIST -->
      </v-row>
    </v-container>

    <!-- VIEW TOOL DIALOG -->
  </ais-instant-search>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "lodash";
import fb from "@/main";
import NonEscapedHighlight from "../components/search/NonEscapedHighlight";
export default {
  components: {
    NonEscapedHighlight,
  },
  data() {
    return {
      fab: false,
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "image",
          width: 60,
        },
        { text: "Name", value: "title", width: "200" },
        { text: "Description", value: "description" },
        { text: "", value: "other", width: "100" },
      ],
      currentRefinement: "",
      filterSelection: null,
      currentTool: null,
      viewToolDialog: false,
    };
  },
  async created() {
    // load tools from local storage if any
    this.$store.dispatch("loadToolsFromLocal");
  },
  computed: {
    ...mapState(["newCart", "searchClient"]),
  },
  methods: {
    viewTool(tool) {
      this.inCartQty = null;
      this.currentTool = { ...tool, qty: 0 };
      this.viewToolDialog = true;
      const found = this.newCart.find((t) => t.id == tool.objectID);
      if (found) this.inCartQty = found.qty;
    },
    addToCart(tool) {
      if (tool.qty > 0) {
        this.$store.commit("addToCart", tool);
        this.viewToolDialog = false;
      } else {
        alert("Quantity has to be a number greater than zero.");
      }
    },
    loadMore() {
      this.itemsPerPage = this.itemsPerPage + 20;
    },
    search: debounce((refine, event) => {
      refine(event);
    }, 400),
    filter(refine, val) {
      fb.analytics.logEvent("tool_search_filter", { name: val });
      refine(val);
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    newCartCount() {
      this.newCart.length;
    },
  },
};
</script>
<style>
.ais-Highlight mark {
  background-color: #fff1ae;
}

.caption-plus {
  font-size: 0.75rem !important;
  font-weight: 400;
  line-height: 1.15rem;
  font-family: "Roboto", sans-serif !important;
}
.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
  background: none !important;
}
.qty input {
  text-align: center !important;
}

#toolSearch thead.v-data-table-header.v-data-table-header-mobile {
  display: none;
}
#toolSearch .v-data-table .v-data-table__mobile-row {
  min-height: 40px !important;
}
#toolSearch .v-data-table__mobile-row__header {
  display: none;
}
#toolSearch td.v-data-table__mobile-row {
  justify-content: flex-end;
}
</style>
